import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Capacitor } from "@capacitor/core";

@Component({
  selector: "app-demande-service-upload-card",
  templateUrl: "./demande-service-upload-card.component.html",
  styleUrls: ["./demande-service-upload-card.component.scss"],
})
export class DemandeServiceUploadCardComponent {
  @Input() filesPaths: any[] = [];
  @Input() hasMedia = false;
  @Input() canAddMoreMedia = true;

  @Output() selectImage = new EventEmitter<void>();
  @Output() openCamera = new EventEmitter<void>();
  @Output() openGallery = new EventEmitter<void>();
  @Output() removeImage = new EventEmitter<number>();
  @Output() displayMedia = new EventEmitter<{ path: string; type: string }>();

  onSelectImage(): void {
    if (!this.canAddMoreMedia) return;
    const platform = Capacitor.getPlatform();

    if (platform === "android" || platform === "web") {
      this.selectImage.emit();
      return;
    }

    this.openGallery.emit();
  }
}
